import React, {useMemo} from 'react';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import './calendar.scss';

const localizer = momentLocalizer(moment);

const messages = {
  'allDay': 'Todo el día',
  'previous': 'Anterior',
  'next': 'Siguiente',
  'today': 'Hoy',
  'month': 'Mes',
  'week': 'Semana',
  'day': 'Día',
  'agenda': 'Agenda',
  'date': 'Fecha',
  'time': 'Hora',
  'event': 'Evento',
  'noEventsInRange': 'Sin eventos',
  'showMore': (total) => `+${total} más`,
};

const BigCalendar = ({eventsList, componentsList}) => {
  const events = useMemo(() => {
    return eventsList;
  }, [eventsList]);
  
  return (
    <div style={{'height': '70vh'}}>
      <Calendar
        localizer={localizer}
        messages={messages}
        events={events || []}
        components={componentsList}
        showAllEvents={false}
      />
    </div>
  );
};

export default BigCalendar;
